<template>
  <div>
    <slot></slot>

    <!--Main title-->
    <div class="title-row left-aligned">
      <div class="big-title">Get your own charts!</div>
      <div
        class="sub-title"
      >You can generate these beautiful charts for your own Tinder history! Just request your historical user data from Tinder and upload the file here!</div>
    </div>

    <!--Page toggle with 2 buttons-->
    <PageNavToggle v-on:pageSwitch="switchPage" :defaultSelection="this.defaultSelection" />

    <!--Toggleable tutorial-->
    <TutorialContainer v-if="activePageId === 1"/>

    <Popup v-if="showPopup" v-on:closePopup="closePopup" type="TC" share_url>Terms of Service</Popup>
    <Backdrop v-if="showPopup"/>

    <UploadField
      v-if="activePageId"
      v-on:openPopup="openPopup"
      v-on:generateCharts="routeToVizPage"
    />
  </div>
</template>

<script>
import UploadField from "./../components/UploadField.vue";
import Popup from "./../components/Popup.vue";
import PageNavToggle from "./../components/PageNavToggle.vue";
import * as scrollHandler from "../providers/scroll-handler.js";
import Backdrop from "../components/layout/Backdrop.vue";
import TutorialContainer from "../components/TutorialContainer.vue";

export default {
  name: "upload",
  components: {
    UploadField,
    Popup,
    Backdrop,
    PageNavToggle,
    TutorialContainer
  },
  data() {
    return {
      showPopup: false,
      activePageId: null,
      defaultSelection: null
    };
  },
  created() {
    if (this.$route.query.tutorial) {
      this.defaultSelection = 1
      this.switchPage(1)
    }
    this.$store.state.analytics.logEvent("uploadpage visited");
  },
  methods: {
    switchPage(id) {
      this.activePageId = id;
      if (this.activePageId === 1) {
        this.$store.state.analytics.logEvent("visits tutorial subpage");
      } else if (this.activePageId === 2) {
        this.$store.state.analytics.logEvent("visits upload subpage");
      }
    },
    openPopup() {
      this.showPopup = true;
      this.$store.state.analytics.logEvent("opens t&c popup");
      scrollHandler.disableBackgroundScrolling();
    },
    closePopup() {
      this.showPopup = false;
      scrollHandler.enableBackgroundScrolling();
    },
    routeToVizPage() {
      this.$router.push({
        name: "visualization"
      });
    }
  }
};
</script>

<style scoped>
.page-link.pink-button {
  margin-top: 25px;
}

.disabled {
  opacity: 0.5;
}

.title-row {
  width: 85%;
  max-width: 1000px;
  margin: 20px 0;
}

.title-row .big-title {
  margin-bottom: 20px;
}
</style>
